import { DependencyList, useState } from 'react';

import useDebounce from 'react-use/lib/useDebounce';

export const useDebouncedValue = <T extends any>(
  cb: () => T,
  ms: number,
  deps?: DependencyList,
): T => {
  const [value, setValue] = useState(cb());

  useDebounce(
    () => {
      setValue(cb());
    },
    ms,
    deps,
  );

  return value;
};
